var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "email-preview",
      style: _vm.$parent.$parent.emails.length > 1 ? "cursor: pointer;" : ""
    },
    [
      _c(
        "div",
        {
          staticClass: "email-preview-head",
          on: {
            click: function($event) {
              return _vm.haveShowMain()
            }
          }
        },
        [
          _c("div", { staticClass: "personal" }),
          _vm._v(" "),
          _c("div", { staticClass: "email-preview-user" }, [
            _c("div", { staticClass: "email-preview-from" }, [
              _vm._v(_vm._s(_vm._f("fromFilter")(_vm.email.from)))
            ]),
            _vm._v(" "),
            !(_vm.isShowMain && !_vm.isLoadingMain)
              ? _c("div", {
                  staticClass: "email-preview-snippet",
                  domProps: { innerHTML: _vm._s(_vm.email.snippet) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isShowMain && !_vm.isLoadingMain
              ? _c("div", { staticClass: "email-preview-to" }, [
                  _c("div", { staticStyle: { float: "left" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.emailExploer.to") +
                          ": " +
                          _vm.emailDetail.to
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "icon-util down-position email-preview-user-down",
                      on: {
                        mouseover: function($event) {
                          _vm.isUserDetail = true
                        },
                        mouseleave: function($event) {
                          _vm.isUserDetail = false
                        }
                      }
                    },
                    [
                      _vm.isUserDetail
                        ? _c(
                            "div",
                            { staticClass: "email-preview-user-detail" },
                            [
                              _c(
                                "el-scrollbar",
                                { staticStyle: { height: "100%" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "table" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "user-detail-item" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-detail-item-head"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.emailExploer.from"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-detail-item-msg"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.emailDetail.from)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.emailDetail.toUsers, function(
                                        toUser,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "user-detail-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "user-detail-item-head"
                                              },
                                              [
                                                index == 0
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.emailExploer.to"
                                                          )
                                                        ) + ":"
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "user-detail-item-msg"
                                              },
                                              [
                                                _vm._v(_vm._s(toUser)),
                                                index !=
                                                _vm.emailDetail.toUsers.length -
                                                  1
                                                  ? _c("span", [_vm._v(",")])
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.emailDetail.ccUsers, function(
                                        ccUser,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "user-detail-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "user-detail-item-head"
                                              },
                                              [
                                                index == 0
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.emailExploer.cc"
                                                          )
                                                        ) + ":"
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "user-detail-item-msg"
                                              },
                                              [
                                                _vm._v(_vm._s(ccUser)),
                                                index !=
                                                _vm.emailDetail.ccUsers.length -
                                                  1
                                                  ? _c("span", [_vm._v(",")])
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.$route.query.cloudType == "gmail"
            ? _c("div", { staticClass: "email-preview-date" }, [
                _vm._v(_vm._s(_vm.email.date))
              ])
            : _c("div", { staticClass: "email-preview-date" }, [
                _vm._v(_vm._s(_vm._f("transferTime")(_vm.email.date)))
              ])
        ]
      ),
      _vm._v(" "),
      _vm.isShowMain
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoadingMain,
                  expression: "isLoadingMain"
                }
              ],
              staticClass: "email-preview-body"
            },
            [
              _vm.emailDetail
                ? _c(
                    "div",
                    { staticClass: "email-preview-main" },
                    [
                      _c("email-text", {
                        ref: "emailText",
                        attrs: { text: _vm.emailItem.text }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.emailItem && _vm.attachmentArray.length > 0
                ? _c(
                    "div",
                    { staticClass: "email-preview-appendixs" },
                    [
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "email-preview-appendixs-title" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.attachmentArray.length + " attachment(s)"
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.attachmentArray, function(appendix, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "email-preview-appendix" },
                          [
                            _c("div", { staticClass: "appendix-img" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "appendix-msg" }, [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("ellipsis")(appendix.attachmentName)
                                  ) + _vm._s(_vm._f("ellipsis")(appendix.name))
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { color: "#999999" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatByte")(
                                      appendix.attachmentSize
                                    )
                                  ) +
                                    _vm._s(_vm._f("formatByte")(appendix.size))
                                )
                              ])
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a308e7fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a308e7fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview/email_exploer.vue
// module id = null
// module chunks = 